import React, { useMemo } from 'react';
import LoadingSpinner from 'components/LoadingSpinner'; // eslint-disable-line
import EmptyState from 'components/EmptyState/EmptyState';
import ErrorMessage from 'components/ErrorMessage';
// @ts-ignore
import ReactTable from 'react-table-legacy';
import { TRANSLATIONS } from 'types/enums';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import selectDriverManagementSystem from 'store/selectors/driverManagementSystem.selectors';
import {
  customDMSDataSelectorByYearMonthTypeBuAndSubType,
  customDMSDataSelectorByYearMonthTypeAndSubType,
  DMSSelectorTypes,
  DMSSelectorSubTypes,
} from '../dmsHelper';
import './TopCdsDMSStyles.scss';

type Props = {
  isTopOffenders: boolean,
  bu?: string,
  loading: boolean;
  month: string;
  year: number;
  error: boolean;
};

const TopCds = (
  { isTopOffenders, bu, loading, month, year, error }: Props,
) => {
  const { t } = useTranslation();

  const driverManagementSystemData = useSelector(selectDriverManagementSystem);

  const tableData = useMemo(() => {
    if (!loading) {
      let selectedMonthData;
      if (bu) {
        if (isTopOffenders) {
          selectedMonthData = customDMSDataSelectorByYearMonthTypeBuAndSubType(
            driverManagementSystemData,
            year,
            month,
            DMSSelectorTypes.tablePerBu,
            bu,
            DMSSelectorSubTypes.topOffenders,
          );
        } else {
          selectedMonthData = customDMSDataSelectorByYearMonthTypeBuAndSubType(
            driverManagementSystemData,
            year,
            month,
            DMSSelectorTypes.tablePerBu,
            bu,
            DMSSelectorSubTypes.topBest,
          );
        }
      } else if (isTopOffenders) {
        selectedMonthData = customDMSDataSelectorByYearMonthTypeAndSubType(
          driverManagementSystemData,
          year,
          month,
          DMSSelectorTypes.table,
          DMSSelectorSubTypes.topOffenders,
        );
      } else {
        selectedMonthData = customDMSDataSelectorByYearMonthTypeAndSubType(
          driverManagementSystemData,
          year,
          month,
          DMSSelectorTypes.table,
          DMSSelectorSubTypes.topBest,
        );
      }
      if (selectedMonthData) {
        return selectedMonthData.slice(0, 10);
      }
      return [];
    }

    return [];
  }, [bu, driverManagementSystemData, isTopOffenders, loading, month, year]);

  const title = isTopOffenders ? 'CD: Top Offenders' : 'CD: Top Best';
  const color = isTopOffenders ? '#B12419' : '#5572B9';

  const columns = [
    {
      id: 'number',
      accessor: 'number',
      minWidth: 45,
      Cell: (row: any) => (
        <p className="text-left row-data margin-left-25">
          {row.index + 1}
        </p>
      ),
    },
    {
      Header: () => <span className="font-bold">BU</span>,
      id: 'bu',
      accessor: 'bu',
      minWidth: 95,
      Cell: (row: any) => (
        <p className="text-left row-data margin-left-26">
          {row.value}
        </p>
      ),
    },
    {
      Header: () => <span className="font-bold">{`${t(TRANSLATIONS.ROUTINE_COMPLIANCE_CD)}`}</span>,
      id: 'name',
      accessor: 'name',
      Cell: (row: any) => (
        <p className="text-left row-data margin-left-26">
          {row.value}
        </p>
      ),
    },
    {
      Header: () => <span className="font-bold">Registros</span>,
      id: 'totalIncidents',
      accessor: 'totalIncidents',
      Cell: (row: any) => {
        return (
          <p style={{ color }} className="text-left margin-left-25">
            {`${(row.value || 0).toLocaleString()}`}
          </p>
        );
      },
    },
  ];

  if (error) return <ErrorMessage />;
  if (loading) {
    return (
      <div>
        <LoadingSpinner height={271} />
      </div>
    );
  }
  if (!tableData.length) {
    return (
      <div className="overview-locations-top-bottom">
        <EmptyState />
      </div>
    );
  }

  return (
    <div className="dms">
      <div className="top-cds">
        <span className="top-cds__title" style={{ color }}>{title}</span>
        <ReactTable
          data={tableData}
          columns={columns}
          showPagination={false}
          defaultPageSize={tableData?.length}
          className="-striped"
          key={bu}
          NoDataComponent={() => <EmptyState />}
        />
      </div>
    </div>
  );
};

export default TopCds;
